export default __webpack_public_path__ + "static/media/arrows-rotate-solid.d65cd3e4.svg";